import { responsiveFontSizes } from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    white: Palette["primary"];
    active: Palette["primary"];
  }
  interface PaletteOptions {
    white: PaletteOptions["primary"];
    active: PaletteOptions["primary"];
  }
}

let theme = createTheme({
  palette: {
    type: "dark",
    primary: {
      main: "#19B586",
      contrastText: "#030C15",
      dark: "#009966",
    },
    secondary: {
      main: "#EB5757",
      dark: "#A43C3C",
      light: "#EF7878",
      contrastText: "#030C15",
    },
    background: {
      default: "#141719",
      // default: "#141818",
      paper: "#1A2226",
      // paper: "#212729",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#C1C1C1",
    },
    white: {
      main: "#FFFFFF",
    },
    active: {
      main: "#FFB400",
    },
  },
  typography: {
    fontFamily: "NotoSan",
    // fontFamily: "",
  },
});

theme = createTheme(theme, {
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: 12,
      },
    },
    MuiFormHelperText: {
      root: {
        // fontWeight:600,
        fontSize: 13,
        // letterSpacing:0.5,
        // fontFamily:"Helvetica",
      },
    },
    MuiTypography: {
      h6: {
        fontFamily: "NotoSanThai, NotoSan",
      },
      h5: {
        fontFamily: "NotoSanThai, NotoSan",
      },
      h4: {
        fontFamily: "NotoSanThai, NotoSan",
      },
      h3: {
        fontFamily: "NotoSanThai, NotoSan",
      },
      h2: {
        fontFamily: "NotoSanThai, NotoSan",
      },
      h1: {
        fontFamily: "NotoSanThai, NotoSan",
      },
      subtitle1: {
        fontFamily: "NotoSanThai, NotoSan",
      },
      subtitle2: {
        fontFamily: "NotoSanThai, NotoSan",
      },
      body1: {
        fontFamily: "NotoSerifThai, NotoSerif, NotoSan",
      },
      body2: {
        fontFamily: "NotoSerifThai, NotoSerif, NotoSan",
      },
    },
    MuiTabs: {
      indicator: {
        backgroundColor: "#19B586",
        color: "#19B586",
      },
      root: {
        minHeight: "40px",
        minWidth: "60px",
        padding: "0 8px",
        borderColor: "#19B586",
        borderWidth: "1px",
        borderStyle: "none none none none",
      },
    },
    MuiFormControl: {
      root: {
        "& .MuiFilledInput-root": {
          border: `1px solid`,
          borderColor: () =>
            theme.palette.type === "light"
              ? "rgba(0, 0, 0, 0.23)"
              : "rgba(255, 255, 255, 0.23)",
          borderRadius: 20,
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          backgroundColor: "transparent",
          "&:hover": {
            borderColor: theme.palette.text.primary,
            backgroundColor: "transparent",
          },
          "&.Mui-error": {
            borderColor: "#f44336 !important",
          },
          "&.Mui-disabled": {
            backgroundColor: "transparent",
            borderColor: () =>
              theme.palette.type === "light"
                ? "rgba(0, 0, 0, 0.23)"
                : "rgba(255, 255, 255, 0.23)",
            cursor: "default",
            "&:hover": {
              borderColor: () =>
                theme.palette.type === "light"
                  ? "rgba(0, 0, 0, 0.23)"
                  : "rgba(255, 255, 255, 0.23)",
            },
          },
          "& .MuiFilledInput-input": {
            padding: "27px 12px 10px",
          },
          "& .MuiFilledInput-inputAdornedStart": {
            paddingLeft: "0",
          },
          "& .MuiFilledInput-inputAdornedEnd": {
            paddingRight: "0",
          },
          "&.Mui-focused": {
            borderWidth: 2,
            backgroundColor: "transparent",
            borderColor: theme.palette.primary.main,
            "& .MuiFilledInput-input": {
              padding: "26px 11px 9px",
            },
          },
          "&.Mui-focused.MuiFilledInput-adornedStart": {
            paddingLeft: "11px",
            "& .MuiFilledInput-input.MuiFilledInput-inputAdornedStart": {
              padding: "26px 11px 9px 0px",
            },
          },
          "& .MuiInputAdornment-positionEnd": {
            transition: "margin 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
          },
          "&.Mui-focused .MuiInputAdornment-positionEnd": {
            marginTop: "16px",
          },
          "&.Mui-focused.MuiFilledInput-adornedEnd": {
            paddingRight: "11px",
            "& .MuiFilledInput-input.MuiFilledInput-inputAdornedEnd": {
              padding: "26px 0px 9px 11px",
            },
          },
          "&.Mui-focused.MuiFilledInput-adornedStart.MuiFilledInput-adornedEnd":
            {
              "& .MuiFilledInput-input.MuiFilledInput-inputAdornedStart.MuiFilledInput-inputAdornedEnd":
                {
                  padding: "26px 0px 9px 0px",
                },
            },
        },
        "& .MuiInputLabel-filled.MuiInputLabel-shrink + .MuiFilledInput-root": {
          "& .MuiInputAdornment-positionEnd": {
            marginTop: "16px",
          },
        },
        "& .MuiFilledInput-underline": {
          "&:after": {
            borderBottom: "none",
          },
          "&.Mui-disabled:before": {
            borderBottomStyle: "none",
          },
          "&:before": {
            borderBottom: "none",
          },
          "&:hover:before": {
            borderBottom: "none",
          },
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 20,
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: 20,
      },
    },
    MuiMenu: {
      paper: {
        borderRadius: 20,
        // backgroundColor:"#25292b"
        // boxShadow: "rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px",
      },
    },
    MuiButton: {
      contained: {
        fontWeight: 600,
        backgroundColor: "#19B586",
        "&:hover": {
          backgroundColor: "#117E5D",
        },
      },
      root: {
        fontWeight: 600,
        borderRadius: "20px",
      },
    },
    MuiButtonGroup: {
      grouped: {
        borderRadius: 20,
      },
    },
    MuiCard: {
      root: {
        borderRadius: 20,
      },
    },
    MuiFormLabel: {
      asterisk: {
        // color:'red'
      },
    },
    MuiList: {
      root: {
        borderRadius: 20,
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
